<form [formGroup]="uploadForm">
  @for (image of imageList; track image) {
    <div class="img-thumbnail-wrapper preview">
      <img class="thumbnail" src="{{ image.publicUrl }}" />
      <div class="img-buttons">
        <button
          (click)="onRemove(image.id)"
          mat-stroked-button
          class="button"
          color="default"
          type="button"
          >
          Remove
        </button>
      </div>
    </div>
  }

  <div class="form-group">
    <button (click)="fileInput.click()" mat-flat-button color="default">
      Select image
      <input
        #fileInput
        (change)="uploadFile($event)"
        accept="image/*"
        name="..."
        type="file"
        />
    </button>
  </div>
</form>
